import styled from "@emotion/styled";
import React from "react";

import PdfReader from "../../components/PdfReader.js/PdfReader";
import Footer from "../../components/Footer";

const RegulamentationTab = (props) => {
  const pdfUrl =
    "https://image.sfmc.palmeiras.com.br/lib/fe3511747364047d711073/m/1/947fc8ba-12cb-4804-b876-84654562abae.pdf";

  return (
    <Container>
      <div className="Content">
        <div className="title-container">
          <span className="screen-title">Regulamento</span>
        </div>
        <div className="pdf-container">
          <PdfReader pdf={pdfUrl} />
        </div>
      </div>
    </Container>
  );
};

export default RegulamentationTab;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100vw;

  .Content {
    display: flex;
    flex-direction: column;
    justify-content: center!important;
    align-items: center;
    width: 100vw;
    max-width: 1500px;
    margin: 88px 0 45px 0;
    gap: 24px;

    @media (max-width: 768px) {
      margin: 45px 0 45px 0;
    }
  }

  .screen-title {
    font-family: "Roboto Condensed";
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    text-transform: uppercase;
  }

  .pdf-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    padding: 16px;
  }
`;
